import { css } from "lit";

export const styles = css`
  .preview-fields {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
  }

  .preview-fields.desktop {
    grid-column: 2;
    grid-row: 2;
    padding-top: var(--sds-size-space-1200);
  }

  .upload-label {
    color: var(--wow-input-label-color, var(--sds-color-text-default-default));
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-body-size-large);
    font-weight: var(--sds-typography-weight-medium);
    line-height: 1;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding: 0 var(--sds-size-space-2400);
  }

  .cover-uploader-container {
    display: flex;
    aspect-ratio: 16 / 9;
    border-radius: var(--sds-size-radius-400);
    overflow: hidden;
    padding: 0 var(--sds-size-space-2400);
  }

  .cover-uploader-container media-uploader {
    width: 100%;
    height: 100%;
  }

  .thumbnail-error {
    color: var(--sds-color-text-danger-secondary);
    font:
      var(--sds-typography-weight-medium) var(--sds-typography-body-size-small) / 100% var(--sds-typography-family-body),
      sans-serif;
    padding: 0 var(--sds-size-space-2400);
  }

  .cover-uploader-divider {
    border-bottom: 1px solid var(--sds-color-border-default-default);
  }

  .preview-panel-content {
    padding: 0 var(--sds-size-space-2400);
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-1200);
  }

  /* Mobile specific styles */
  .preview-fields.mobile .upload-label {
    padding: 0;
  }

  .preview-fields.mobile .cover-uploader-container {
    padding: 0;
  }

  .preview-fields.mobile .thumbnail-error {
    padding: 0;
  }

  .preview-fields.mobile .cover-uploader-divider {
    display: none;
  }

  .preview-fields.mobile .preview-panel-content {
    padding: 0;
  }

  @media (max-width: 1100px) {
    .preview-fields.desktop .upload-label {
      padding: 0 0 0 var(--sds-size-space-1200);
    }

    .preview-fields.desktop .cover-uploader-container {
      padding: 0 0 0 var(--sds-size-space-1200);
    }

    .preview-fields.desktop .thumbnail-error {
      padding: 0 0 0 var(--sds-size-space-1200);
    }

    .preview-fields.desktop .preview-panel-content {
      padding: 0 0 0 var(--sds-size-space-1200);
    }
  }
`;
